const connectors = {
    page_title: 'คอนเนคเตอร์',
    title: 'คอนเนคเตอร์',
    subtitle: 'ตั้งค่าคอนเนคเตอร์เพื่อเปิดใช้งานประสบการณ์การเข้าสู่ระบบแบบไม่ใช้รหัสผ่านและโซเชียล',
    create: 'เพิ่มคอนเนคเตอร์โซเชียล',
    config_sie_notice: 'คุณได้ตั้งค่าคอนเนคเตอร์แล้ว อย่าลืมกำหนดค่าใน <a>{{link}}</a>.',
    config_sie_link_text: 'ประสบการณ์การเข้าสู่ระบบ',
    tab_email_sms: 'คอนเนคเตอร์อีเมลและ SMS',
    tab_social: 'คอนเนคเตอร์โซเชียล',
    connector_name: 'ชื่อคอนเนคเตอร์',
    demo_tip: 'จำนวนข้อความสูงสุดที่อนุญาตสำหรับคอนเนคเตอร์เดโมนี้จำกัดไว้ที่ 100 ข้อความ และไม่แนะนำให้นำไปใช้ในสภาพแวดล้อมการผลิต',
    social_demo_tip: 'คอนเนคเตอร์เดโมนี้ออกแบบมาเพื่อใช้สำหรับสาธิตเท่านั้น และไม่แนะนำให้นำไปใช้ในสภาพแวดล้อมการผลิต',
    connector_type: 'ประเภท',
    placeholder_title: 'คอนเนคเตอร์โซเชียล',
    placeholder_description: 'Logto มีคอนเนคเตอร์โซเชียลที่นิยมใช้หลากหลายแบบให้คุณเลือก และคุณยังสามารถสร้างของคุณเองด้วยโปรโตคอลมาตรฐานได้',
    save_and_done: 'บันทึกและเสร็จสิ้น',
    type: {
        email: 'คอนเนคเตอร์อีเมล',
        sms: 'คอนเนคเตอร์ SMS',
        social: 'คอนเนคเตอร์โซเชียล',
    },
    setup_title: {
        email: 'ตั้งค่าคอนเนคเตอร์อีเมล',
        sms: 'ตั้งค่าคอนเนคเตอร์ SMS',
        social: 'เพิ่มคอนเนคเตอร์โซเชียล',
    },
    guide: {
        subtitle: 'คำแนะนำทีละขั้นตอนในการตั้งค่าคอนเนคเตอร์ของคุณ',
        general_setting: 'การตั้งค่าทั่วไป',
        parameter_configuration: 'การกำหนดค่าพารามิเตอร์',
        test_connection: 'ทดสอบการเชื่อมต่อ',
        name: 'ชื่อปุ่มเข้าสู่ระบบโซเชียล',
        name_placeholder: 'กรอกชื่อสำหรับปุ่มเข้าสู่ระบบโซเชียล',
        name_tip: 'ชื่อของปุ่มคอนเนคเตอร์จะแสดงเป็น "ดำเนินการต่อด้วย {{name}}" โปรดระวังความยาวของชื่อเพราะอาจยาวเกินไปได้',
        connector_logo: 'โลโก้คอนเนคเตอร์',
        connector_logo_tip: 'โลโก้จะแสดงบนปุ่มเข้าสู่ระบบของคอนเนคเตอร์',
        target: 'ชื่อผู้ให้บริการระบุตัวตน',
        target_placeholder: 'กรอกชื่อผู้ให้บริการระบุตัวตนของคอนเนคเตอร์',
        target_tip: 'ค่า "ชื่อ IdP" สามารถเป็นสตริงที่ไม่ซ้ำกันเพื่อแยกแยะโซเชียลไอดีของคุณ',
        target_tip_standard: 'ค่า "ชื่อ IdP" สามารถเป็นสตริงที่ไม่ซ้ำกันเพื่อแยกแยะโซเชียลไอดีของคุณ การตั้งค่านี้จะไม่สามารถเปลี่ยนแปลงได้หลังจากสร้างคอนเนคเตอร์แล้ว',
        target_tooltip: '"ชื่อ IdP" ในคอนเนคเตอร์โซเชียลของ Logto หมายถึง "แหล่งที่มา" ของโซเชียลไอดีของคุณ ในการออกแบบของ Logto เราไม่ยอมรับ "ชื่อ IdP" เดียวกันในแพลตฟอร์มเดียวเพื่อหลีกเลี่ยงปัญหา คุณควรตรวจสอบอย่างรอบคอบก่อนเพิ่มคอนเนคเตอร์เพราะคุณจะไม่สามารถเปลี่ยนค่าได้หลังจากสร้างแล้ว <a>ดูข้อมูลเพิ่มเติม</a>',
        target_conflict: 'ชื่อ IdP ที่ป้อตรงกับคอนเนคเตอร์ <span>name</span> ที่มีอยู่แล้ว การใช้ชื่อ idp ซ้ำอาจก่อให้เกิดปัญหาที่ไม่คาดคิดในการเข้าสู่ระบบ เช่น ผู้ใช้อาจเข้าถึงบัญชีเดียวกันผ่านคอนเนคเตอร์สองตัว',
        target_conflict_line2: 'หากคุณต้องการแทนที่คอนเนคเตอร์ปัจจุบันที่มีผู้ให้บริการระบุตัวตนเดียวกัน และอนุญาตให้ผู้ใช้เดิมเข้าสู่ระบบได้โดยไม่ต้องลงทะเบียนใหม่ โปรดลบคอนเนคเตอร์ <span>name</span> และสร้างใหม่โดยใช้ "ชื่อ IdP" เดิม',
        target_conflict_line3: 'หากคุณต้องการเชื่อมต่อกับผู้ให้บริการระบุตัวตนอื่น โปรดแก้ไข "ชื่อ IdP" แล้วดําเนินการต่อ',
        config: 'กรอกค่าคอนฟิก JSON ของคุณ',
        sync_profile: 'ซิงก์ข้อมูลโปรไฟล์',
        sync_profile_only_at_sign_up: 'ซิงก์เฉพาะตอนสมัครใหม่',
        sync_profile_each_sign_in: 'ซิงก์ทุกครั้งที่เข้าสู่ระบบ',
        sync_profile_tip: 'ซิงก์โปรไฟล์พื้นฐานจากผู้ให้บริการโซเชียล เช่น ชื่อผู้ใช้และอวาตาร์',
        enable_token_storage: {
            title: 'จัดเก็บโทเค่นเพื่อการเข้าถึง API ถาวร',
            description: 'จัดเก็บ access token และ refresh token ไว้ใน Secret Vault ทำให้เรียกใช้งาน API อัตโนมัติโดยไม่ต้องขอความยินยอมจากผู้ใช้ซ้ำ ตัวอย่าง เช่น ให้ AI Agent ของคุณเพิ่มกิจกรรมใน Google Calendar โดยใช้สิทธิ์การอนุญาตถาวร <a>เรียนรู้วิธีเรียกใช้ API ของบุคคลที่สาม</a>',
        },
        callback_uri: 'URI การเปลี่ยนเส้นทาง (Callback URI)',
        callback_uri_description: 'URI การเปลี่ยนเส้นทางคือจุดที่ผู้ใช้ถูกพากลับหลังจากได้รับอนุญาตจากโซเชียลแล้ว เพิ่ม URI นี้ลงในการกำหนดค่าของ IdP ของคุณด้วย',
        callback_uri_custom_domain_description: 'หากคุณใช้ <a>โดเมนแบบกำหนดเอง</a> หลายโดเมนใน Logto อย่าลืมเพิ่ม URI การเรียกกลับที่สอดคล้องกันทั้งหมดลงใน IdP เพื่อให้การเข้าสู่ระบบผ่านโซเชียลทำงานได้ในทุกโดเมน\n\nโดเมนเริ่มต้นของ Logto (*.logto.app) ใช้งานได้เสมอ รวมไว้เฉพาะเมื่อคุณต้องการรองรับการเข้าสู่ระบบภายใต้โดเมนนั้นด้วย',
        acs_url: 'URL สำหรับรับ Assertion Consumer Service',
    },
    platform: {
        universal: 'สากล',
        web: 'เว็บ',
        native: 'เนทีฟ',
    },
    add_multi_platform: ' รองรับหลายแพลตฟอร์ม เลือกแพลตฟอร์มเพื่อดำเนินการต่อ',
    drawer_title: 'คู่มือคอนเนคเตอร์',
    drawer_subtitle: 'ปฏิบัติตามคำแนะนำในการบูรณาการคอนเนคเตอร์ของคุณ',
    unknown: 'คอนเนคเตอร์ที่ไม่รู้จัก',
    standard_connectors: 'คอนเนคเตอร์มาตรฐาน',
    create_form: {
        third_party_connectors: 'ผสานผู้ให้บริการบุคคลที่สามเพื่อเข้าสู่ระบบโซเชียลอย่างรวดเร็ว เชื่อมโยงบัญชีโซเชียล และเข้าถึง API <a>ดูข้อมูลเพิ่มเติม</a>',
        email_connector_upsell: {
            title: 'บริการอีเมลในตัวของ Logto',
            description: 'ส่งอีเมลได้ทันทีโดยไม่ต้องตั้งค่า ส่งรหัสยืนยันและเมจิกลิงก์ได้ตั้งแต่เริ่มต้น',
        },
        standard_connectors: 'หรือคุณสามารถปรับแต่งคอนเนคเตอร์โซเชียลของคุณเองด้วยโปรโตคอลมาตรฐาน',
    },
};
export default Object.freeze(connectors);
